<template>
  <v-container style="margin-top: 2%">
    <v-card class="masterCard">
      <v-progress-circular
        indeterminate
        class="loading"
        color="primary"
        v-if="loading"
      >
        Cargando
      </v-progress-circular>
      <template v-else>
        <v-dialog v-model="GuideDialog" max-width="50%">
          <v-card class="fileUpload">
            <v-card-text>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="editedItem.name"
                    label="Nombre"
                  ></v-text-field>
                  <v-text-field
                    v-model="editedItem.description"
                    label="Descripción"
                  ></v-text-field>
                </v-col>
                <v-col style="width: 40%" align="center">
                  <v-row>
                    <v-col class="fileUpload" align="center">
                      <label class="labelText">Seleccione el archivo</label>

                      <input
                        style="margin-top: 5%"
                        @change="createGuide()"
                        ref="file"
                        type="file"
                        name
                        id="dropzoneFile"
                        accept=".pdf,.jpg,.png,.docx,.xlsx,.ppt,.pptx"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#015CAB" text @click="save">Guardar</v-btn>
              <v-btn color="#E1251B" text @click="close">Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-data-table
        :headers="cHeaders"
        :items="guideList"
        :loading="loading"
        :items-per-page="5"
        :rows-per-page="6"
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Guías</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="GuideDialog">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#015CAB"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  >Agregar guía</v-btn
                >
              </template>
            </v-dialog>
            <v-dialog max-width="20%" v-model="deleteDialog">
              <v-card>
                <v-card-text>
                  ¿Seguro que desea eliminar esta guía?
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#015CAB" text @click="deleteGuide"
                    >Eliminar</v-btn
                  >
                  <v-btn color="#E1251B" text @click="closeDelete"
                    >Cancelar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.date="{ item }">
          {{ filterDate(item.date) }}</template
        >
        <template v-slot:item.name="{ item }">
          {{ getName(item.name) }}</template
        >
        <template v-slot:item.description="{ item }">
          <v-textarea
            auto-grow
            rows="1"
            :value="getName(item.description)"
            disabled
          >
            {{ getName(item.description) }}</v-textarea
          >
        </template>
        <template v-slot:item.controls="{ item }">
          <v-row style="width: 100%">
            <!-- stop prop prevent to trigget the click row event -->
            <v-spacer></v-spacer>
            <v-icon small class="mr-2" @click.stop="downloadFile(item)"
              >mdi-download</v-icon
            >
            <v-icon small class="mr-2" @click.stop="editDialog(item)"
              >mdi-pencil</v-icon
            >
            <v-icon
              small
              class="mr-2"
              @click.stop="deleteConfirmationDialog(item)"
              >mdi-delete</v-icon
            >
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import {
  getGuides,
  addGuide,
  getGuideFile,
  removeGuide,
  updateGuide,
} from "@/utils/apiRequest.js";
import FileSaver from "file-saver";
export default {
  data() {
    return {
      rolesNames: [],
      rolesList: [],
      GuideDialog: false,
      Role: "",
      newRolName: "",
      editedItem: { file: "", name: "", description: "", type: "", date: "" },
      defaultItem: {
        file: "",
        name: "",
        description: "",
        type: "",
        date: "",
      },
      guideList: [],
      loading: true,
      search: "",
      deleteDialog: false,
      cHeaders: [
        { text: "Nombre", value: "name" },
        { text: "Tipo", value: "type" },

        { text: "Fecha", value: "date" },
        { text: "Descripción", value: "description", width: "20%" },
        { text: "", value: "controls" },
      ],
    };
  },
  watch: {
    GuideDialog(val) {
      val || this.close();
    },
    deleteDialog(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    getName(name) {
      if (name == undefined) {
        return name;
      }
      let parts = name.split(".");
      return parts[0];
    },
    filterDate(dateString) {
      let date = new Date(dateString);
      return date.toLocaleString();
    },
    close() {
      this.GuideDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    createGuide() {
      this.editedItem.file = this.$refs.file.files[0];
    },
    async deleteGuide() {
      var guideDeleted = await removeGuide(this.editedItem.id);
      if (guideDeleted.data.status) {
        window.location.reload();
      }
    },
    async downloadFile(item) {
      let response = await getGuideFile(item.id);
      FileSaver.saveAs(response.data, item.name);
    },
    async save() {
      var formData;
      if (this.editedItem.id == undefined) {
        formData = new FormData();
        formData.append("", this.editedItem.file);
        formData.append("id", this.editedItem.id);
        formData.append("name", this.editedItem.name);
        formData.append("description", this.editedItem.description);
        let Guide = await addGuide(formData);
        if (Guide.data.status == "success") {
          window.location.reload();
          this.close();
        }
      }
      formData = new FormData();
      formData.append("", this.editedItem.file);
      formData.append("id", this.editedItem.id);
      formData.append("name", this.editedItem.name);
      formData.append("description", this.editedItem.description);
      let Guide = await updateGuide(this.editedItem.id, formData);
      if (Guide.data.status == "success") {
        window.location.reload();
        this.close();
      }
    },
    editDialog(item) {
      this.edited = true;
      this.editedItem = Object.assign({}, item);
      this.GuideDialog = true;
    },
    deleteConfirmationDialog(item) {
      this.editedItem = Object.assign({}, item);
      this.deleteDialog = true;
    },
    closeDelete() {
      this.deleteDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
  async mounted() {
    let response = await getGuides();
    if (response.data) {
      if (response.data.status == "success") {
        this.guideList = response.data.guide;
      }
    }

    this.guideList.forEach((guide) => {
      guide.name = this.getName(guide.name);
    });

    this.loading = false;
  },
};
</script>

<style scoped>
.masterCard {
  align-self: center;
  margin: 0 auto;
}

.loading {
  position: absolute;
  left: 50%;
  margin: 25% 0 0 0;
}

.labelText {
  font-size: large;
  color: black;
}
</style>